<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" id="modal-basic-title">{{'compromise-reports-title-details' | translate}} {{comproCourante?.id}}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="d('Cross click');resetTitle()"></button>
  </div>
  <div class="modal-body justify-content-center">
    <app-modalpart [attestation]="false" [objetCourant]="comproCourante"
      (filtreApp)="c('Save click');getApp($event)"></app-modalpart>
    <div class="detectorsInfos">
      <div class="d-flex flex-row header-detectors-modal align-items-center justify-content-between">
        <h3>{{'compromise-reports-title-detectors-reminder' | translate}}</h3>
        <div class="d-flex flex-row justify-content-center legend">
          <div class="ok-state d-flex flex-row align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
              <circle cx="10" cy="10" r="10" fill="#46BEAA" />
            </svg>
            <h5>{{'compro-detector-status-ok' | translate}}</h5>
          </div>
          <div class="warning-state d-flex flex-row align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
              <circle cx="10" cy="10" r="10" fill="#FFEB78" />
            </svg>
            <h5>{{'compro-detector-status-warning' | translate}}</h5>
          </div>
          <div class="fatal-state d-flex flex-row align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
              <circle cx="10" cy="10" r="10" fill="#DB0015" />
            </svg>
            <h5>{{'compro-detector-status-fatal' | translate}}</h5>
          </div>
        </div>
      </div>
      <hr class="accordeon-hr">
      <div class="d-flex flex-wrap justify-content-center">
        @for(noms of listeprobes; track noms) {
          <div class="d-flex flex-column justify-content-center">
            @if (hasRequiredRole()) {
              @if(noms === 'black&White') {
                @if(getAllDetectors(noms).length > 0) {
                  <img type="button" [ngbPopover]="pophover" id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                    src="assets/icons/probesFamilies/black&White.png">
                } @else {
                  <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                    src="assets/icons/probesFamilies/black&White.png">
                }
              } @else {
                @if(getAllDetectors(noms).length > 0) {
                  <img type="button" [ngbPopover]="pophover" id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                    src="assets/icons/probesFamilies/{{noms}}.svg">
                } @else {
                  <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                    src="assets/icons/probesFamilies/{{noms}}.svg">
                }
              }
              <ng-template #pophover>
                <div class="d-flex flex-column detectAdmin">
                  @for(d of getAllDetectors(noms); track d.id) {
                    <div class="d-flex flex-row align-items-center justify-content-around">
                      <h6 *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true">0x{{decitohexa(d.id)}}</h6>
                      <span *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true" class="dot"></span>
                      <h6 class="text-capitalize text-center">{{formatDetectorName(d.name)}}</h6>
                    </div>
                  }
                </div>
              </ng-template>
            } @else {
              @if(noms === 'black&White') {
                <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                  src="assets/icons/probesFamilies/black&White.png">
              } @else {
                <img id="probe-{{noms.toLowerCase()}}" class="{{statutProbe(noms)}}"
                  src="assets/icons/probesFamilies/{{noms}}.svg">
              }
            }
            <h4 class="text-capitalize">{{noms}}</h4>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Save click');resetTitle()">{{'back-to-list' | translate}}</button>
  </div>
</ng-template>
<button class="btn btn-lg btn-outline-primary" (click)="open({content : content})">{{'see-more' | translate}}</button>